import { Minus, Plus } from 'lucide-react';
import { cn } from '../utils/cn';

interface QuantitySelectorProps {
  quantity: number;
  onChange: (quantity: number) => void;
  min?: number;
  max?: number;
  className?: string;
}

export function QuantitySelector({ quantity, onChange, min = 1, max = 99, className }: QuantitySelectorProps) {
  return (
    <div className={cn('inline-flex items-center border border-beige rounded', className)}>
      <button
        type="button"
        aria-label="Decrease quantity"
        className="flex h-11 w-11 items-center justify-center text-charcoal transition-colors hover:bg-cream disabled:opacity-30"
        onClick={() => onChange(Math.max(min, quantity - 1))}
        disabled={quantity <= min}
      >
        <Minus className="h-4 w-4" />
      </button>
      <span className="w-10 text-center text-sm font-medium tabular-nums" aria-live="polite">
        {quantity}
      </span>
      <button
        type="button"
        aria-label="Increase quantity"
        className="flex h-11 w-11 items-center justify-center text-charcoal transition-colors hover:bg-cream disabled:opacity-30"
        onClick={() => onChange(Math.min(max, quantity + 1))}
        disabled={quantity >= max}
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
}
